<!--
 * @Author: Asadhcj asadhcj@163.com
 * @Date: 2025-09-13 14:27:13
 * @LastEditors: Asadhcj asadhcj@163.com
 * @LastEditTime: 2026-01-23 14:42:43
 * @FilePath: \betdoce-admind:\new_project\betdoce-web\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang="ts">
import { ref, onMounted, onUnmounted, watch, nextTick, computed } from "vue";
import LoadingSpinner from "./components/LoadingSpinner.vue";
import { toast, showSuccess, closeToast } from "@/utils/toast";
import { getToken } from "@/utils/auth";
import {
  loginEvent,
  SHOW_LOGIN_EVENT,
  supportEvent,
  SUPPORT_EVENT,
} from "@/api/request";
import RewardDialog from "@/components/RewardDialog.vue";
import { depositEvent, DEPOSIT_COMPLETED_EVENT } from "@/api/request";
import LoginDialog from "@/components/LoginDialog.vue";
import CommonDialog from "@/components/CommonDialog.vue";
import AssistanceDialog from "@/components/AssistanceDialog.vue";
import PhoneBindingDialog from "@/components/PhoneBindingDialog.vue";
import TelegramShareDialog from "@/components/TelegramShareDialog.vue";
import {
  loginPopup,
  oncePopup,
  checkActivityBoostPopup,
  // checkActivityRebatePopup,
} from "@/api/activity";
import { getEventCookie } from "@/api/auth";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import websocketService from "@/utils/websocket";
import networkMonitor, { NetworkStatus } from "@/utils/networkMonitor";
import websocketKeeper from "@/utils/websocketKeeper";
import ForbiddenCountry from "./views/ForbiddenCountry.vue";
import WebSocketStatus from "@/components/WebSocketStatus.vue";

import { getUrlKey } from "@/utils/url";
import { GoogleTag, rehydrateSessionFromCookie, getCookie, setCookie } from "@/utils/auth";
import { checkPendingDeposit } from "@/utils/depositPolling";
import EventActivatorTool from "@/components/EventActivatorTool.vue";

// WebSocket状态切换事件名称
const WEBSOCKET_STATUS_TOGGLE_EVENT = "websocket-status-toggle";

const isLoading = ref(true);
const isLogin = ref(false);
const showLoginDialog = ref(false);
const store = useStore();
const route = useRoute();
const router = useRouter();

// Kwai渠道判断已移除

// WebSocket登录状态管理
const websocketLoginSent = ref(false);
const websocketLoginSuccess = ref(false);

// 网络状态响应式引用
const networkStatus = networkMonitor.networkStatus;
const connectionQuality = networkMonitor.connectionQuality;

// 登录活动弹框
const commonDialogShow = ref(false);
const dialogObj = ref();

// 消息弹框
const supportSuccessDialog = ref(false);
const rewardDialog = ref(false);
const rewardAmount = ref<number>(0);

const progress = ref(0);
let progressInterval: number | undefined = undefined;

// O `watch` observa mudanças na visibilidade do diálogo.
watch(supportSuccessDialog, (newValue) => {
  // Se o diálogo for aberto, inicia a barra de progresso.
  if (newValue) {
    startProgress();
  } else {
    // Se for fechado, limpa qualquer intervalo existente.
    clearProgressInterval();
  }
});

const startProgress = () => {
  // Reseta o progresso e limpa intervalos anteriores para segurança.
  progress.value = 0;
  clearProgressInterval();

  const totalDuration = 3000; // 3 segundos em milissegundos
  const intervalTime = 50; // Atualiza a cada 50ms
  const increment = (intervalTime / totalDuration) * 100;

  progressInterval = window.setInterval(() => {
    progress.value += increment;
    if (progress.value >= 100) {
      progress.value = 100; // Garante que não ultrapasse 100
      clearProgressInterval();
      // Fecha o diálogo após a conclusão.
      supportSuccessDialog.value = false;
    }
  }, intervalTime);
};

const clearProgressInterval = () => {
  if (progressInterval) {
    clearInterval(progressInterval);
    progressInterval = undefined;
  }
};

const getLoginPopup = () => {
  loginPopup().then((res: any) => {
    console.log(res);
    if (res.length) {
      commonDialogShow.value = true;
      dialogObj.value = res[0];
    }
  });
};
const getLoginPopupOnce = () => {
  oncePopup().then((res: any) => {
    console.log(res);
    if (res.length) {
      commonDialogShow.value = true;
      dialogObj.value = res[0];
      localStorage.setItem("dialogOnce", "true");
    }
  });
};

// 最小加载动画显示时间 (毫秒)
const MIN_LOADING_TIME = 200; // 确保 SVG 动画播放完毕 (3.5s + buffer)

// 初始化系统
const initializeSystem = async () => {
  const startTime = Date.now();
  try {
    // 如果有 token，获取用户信息
    if (getToken()) {
      await store.dispatch("auth/fetchUserInfo");
    }
    // 检查 inviteCode
    if (localStorage.getItem("inviteCode") && !getToken()) {
      // showLoginDialog.value = true;
    }

    // Kwai 管理器已移除

    // 这里可以添加其他系统初始化需要的操作
  } catch (error) {
    console.error("Initialization failed:", error);
    // Handle initialization error if needed
  } finally {
    const elapsedTime = Date.now() - startTime;
    const remainingTime = MIN_LOADING_TIME - elapsedTime;

    if (remainingTime > 0) {
      // 如果初始化时间小于最小显示时间，则等待剩余时间
      setTimeout(() => {
        isLoading.value = false;
      }, remainingTime);
    } else {
      // 如果初始化时间已经足够长，则立即隐藏加载动画
      isLoading.value = false;
    }
  }
};

// 处理登录成功
const handleLoginSuccess = async () => {
  showLoginDialog.value = false;
  await getLoginPopup();
};
// 处理登录弹窗事件
const handleShowLogin = (event: any) => {
  if (!showLoginDialog.value) {
    showLoginDialog.value = true;
  }
  if (event?.detail?.isLogin) {
    isLogin.value = event.detail?.isLogin;
  } else {
    isLogin.value = false;
  }
};

// 处理助力成功消息弹窗事件
const handleShowSupport = async () => {
  if (!supportSuccessDialog.value) {
    supportSuccessDialog.value = true;
  }
  await store.dispatch("auth/fetchUserInfo");
};

const handleDepositCompleted = (e: CustomEvent) => {
  const amt = Number((e.detail as any)?.amount || 0);
  if (amt > 0) {
    rewardAmount.value = amt;
    rewardDialog.value = true;
  }
};

// 创建SSE推送链接
const eventSource = ref();
const initSSE = () => {
  if (typeof EventSource !== "undefined") {
    eventSource.value = new EventSource(
      `${window.location.origin}/front/activity-events/jackpot-update`
    );
    eventSource.value.addEventListener(
      "open",
      function (open: any) {
        console.log("SSE已成功打开");
      },
      false
    );
    eventSource.value.addEventListener("message", (event: { data: any }) => {
      // console.log("收到消息内容是:", JSON.parse(event.data));
      const msg = JSON.parse(event.data);
      //  store.dispatch('jackpot/updateJackpotBalance',{amount: 20,time:msg.time});;
      if (msg?.id) {
        switch (msg?.id) {
          case 2:
            // 更新獎池數據
            // store.dispatch("jackpot/updateJackpotBalance", msg);
            break; /* 可選的 */
          case 3:
            if (msg.user_id === store.state.auth.user.id) {
              showSuccess(msg.invitee_id + "Ajudando você a ter sucesso");
            }

            break; /* 可選的 */
          /* 您可以有任意数量的 case 语句 */
          default: /* 可选的 */
        }
      }
    });
    eventSource.value.addEventListener(
      "error",
      (error: { currentTarget: any }) => {
        console.log("SSE 连接出错：", error);
        let { currentTarget } = error;
        console.log("SSE 连接出错：", currentTarget);
        if (currentTarget.readyState === 2) {
          setTimeout(() => {
            initSSE();
          }, 360000);
        }
        // eventSource.close();
      }
    );
  }
};

/**
 * 当元素进入视口时预加载资源
 * @param elementSelector 元素选择器
 * @param resourceUrl 资源地址
 * @param options 可选项：type（资源类型），onLoaded（加载完成回调）
 */
function preloadWhenVisible(
  elementSelector: string,
  resourceUrl: string,
  options?: {
    type?: "image" | "script" | "style" | "auto";
    onLoaded?: () => void;
  }
) {
  const { type = "auto", onLoaded } = options || {};
  const observedElements = new Set<Element>();

  const getResourceType = () => {
    if (type !== "auto") return type;
    if (/\.(jpg|jpeg|png|gif|webp|svg)$/i.test(resourceUrl)) return "image";
    if (/\.(js)$/i.test(resourceUrl)) return "script";
    if (/\.(css)$/i.test(resourceUrl)) return "style";
    return "auto";
  };

  const preloadResource = (url: string) => {
    const resourceType = getResourceType();
    let el: HTMLLinkElement | HTMLImageElement | HTMLScriptElement | null =
      null;

    switch (resourceType) {
      case "image":
        el = new Image();
        el.src = url;
        el.onload = () => onLoaded && onLoaded();
        break;
      case "script":
        el = document.createElement("script");
        el.src = url;
        el.async = true;
        el.onload = () => onLoaded && onLoaded();
        document.head.appendChild(el);
        break;
      case "style":
        el = document.createElement("link");
        el.rel = "stylesheet";
        el.href = url;
        el.onload = () => onLoaded && onLoaded();
        document.head.appendChild(el);
        break;
      default:
        el = document.createElement("link");
        el.rel = "preload";
        el.href = url;
        el.as = "fetch";
        el.onload = () => onLoaded && onLoaded();
        document.head.appendChild(el);
    }
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !observedElements.has(entry.target)) {
        observedElements.add(entry.target);
        preloadResource(resourceUrl);
        observer.unobserve(entry.target);
      }
    });
  });

  const elements = document.querySelectorAll(elementSelector);
  elements.forEach((el) => observer.observe(el));
}
async function websocketToken() {
  // 获取用户信息
  const userInfo = store.state.auth.user;
  if (!userInfo || !userInfo.uuid) {
    console.log("User information incomplete, skipping WebSocket login");
    console.log("User information incomplete, skipping WebSocket login");
    return;
  }

  try {
    // 等待下一个tick，确保DOM更新完成
    await nextTick();

    // 确保websocket已连接
    await websocketService.connect();

    // 使用优化后的登录方法
    const success = await websocketService.sendLogin();
    if (success) {
      console.log("WebSocket login message sent successfully");
      // 更新本地状态
      websocketLoginSent.value = true;
      websocketLoginSuccess.value = true;
      localStorage.setItem("isLogin", "false");
    } else {
      console.log("WebSocket login message failed or skipped");
    }
  } catch (error) {
    console.error("Failed to send WebSocket login message:", error);
  }
}

// 监听token状态变化
watch(
  () => store.state.auth.user?.uuid,
  async (user) => {
    if (user || localStorage.getItem("token")) {
      // 有token时调用websocketToken
      websocketToken();
      // 检查并处理未完成的充值订单
      if (store.state.auth.user) {
        setTimeout(() => {
          checkPendingDeposit(store.state.auth.user, store);
        }, 3000);
      }

    } else {
      // 用户登出时重置WebSocket登录状态
      websocketLoginSent.value = false;
      websocketLoginSuccess.value = false;
      websocketService.resetLoginState();
      websocketService.disconnect();
    }
  },
  { immediate: true }
);

// 监听网络状态变化，当网络恢复时重新发送登录消息
watch(
  () => networkStatus.value,
  (newStatus, oldStatus) => {
    console.log(`Network status changed: ${oldStatus} -> ${newStatus}`);

    // 当网络从离线恢复为在线时，重新发送登录消息
    if (
      oldStatus === NetworkStatus.OFFLINE &&
      newStatus === NetworkStatus.ONLINE
    ) {
      console.log("Network recovered, resending WebSocket login message");
      // showSuccess("网络连接已恢复");

      // 重置登录状态，允许重新发送
      websocketLoginSent.value = false;
      websocketLoginSuccess.value = false;
      websocketService.resetLoginState();

      // 延迟发送登录消息，给网络一些恢复时间
      setTimeout(() => {
        if (store.state.auth.user?.uuid) {
          websocketToken();
        }
      }, 2000);
    } else if (newStatus === NetworkStatus.OFFLINE) {
      // showWarning("网络连接已断开");
    } else if (newStatus === NetworkStatus.SLOW) {
      // showWarning("网络连接较慢，可能影响实时通信");
    }
  }
);

// 监听连接质量变化
watch(
  () => connectionQuality.value,
  (newQuality, oldQuality) => {
    if (newQuality.status !== oldQuality.status) {
      console.log(
        `Connection quality changed: ${oldQuality.status} -> ${newQuality.status}, latency: ${newQuality.latency}ms`
      );
    }
  }
);
// 监听网络403状态变化
const isForbiddenCountry = computed(() => {
  return store.state.auth.isForbiddenCountry;
});
// 快捷键状态跟踪
const keyState = ref({
  // ctrl: false,
  // shift: false,
  o: false,
  p: false,
});

// 快捷键处理函数
const handleKeyDown = (event: KeyboardEvent) => {
  // 更新按键状态
  // if (event.key === 'Control') keyState.value.ctrl = true;
  // if (event.key === 'Shift') keyState.value.shift = true;
  if (event.key?.toLowerCase() === "o") keyState.value.o = true;
  if (event.key?.toLowerCase() === "p") keyState.value.p = true;

  // 检查是否按下了完整的快捷键组合 Ctrl+Shift+O+P
  // keyState.value.ctrl && keyState.value.shift &&
  if (keyState.value.o && keyState.value.p) {
    event.preventDefault();
    event.stopPropagation();

    // 触发WebSocket状态切换事件
    window.dispatchEvent(new Event(WEBSOCKET_STATUS_TOGGLE_EVENT));

    console.log(
      "Shortcut Ctrl+Shift+O+P triggered, toggling WebSocket status component"
    );

    // 重置按键状态
    resetKeyState();
  }
};

const handleKeyUp = (event: KeyboardEvent) => {
  // 重置按键状态
  // if (event.key === 'Control') keyState.value.ctrl = false;
  // if (event.key === 'Shift') keyState.value.shift = false;
  if (event.key?.toLowerCase() === "o") keyState.value.o = false;
  if (event.key?.toLowerCase() === "p") keyState.value.p = false;
};

const resetKeyState = () => {
  keyState.value = {
    // ctrl: false,
    // shift: false,
    o: false,
    p: false,
  };
};
const assistanceDialogShow = ref(false);
const activityStatus = ref();
// 监听路由状态
watch(
  () => route.fullPath,
  async (newRoute, oldRoute) => {
    if (
      sessionStorage.getItem("isGameBack") &&
      sessionStorage.getItem("isGameBack") === "true"
    ) {
      sessionStorage.removeItem("isGameBack");
      const res = await checkActivityBoostPopup({});
      if (res.can_trigger) {
        assistanceDialogShow.value = true;
        activityStatus.value = res;
      }
    }
  },
  { immediate: true }
);

// 将orderIdWatcher存储到组件实例中，以便在卸载时清理
const orderIdWatcherRef = ref();
// const updateNotification = ref<InstanceType<typeof UpdateNotification>>(); // 不再需要更新弹窗引用

const loadStatus = ref("页面开始加载...");
const domStatus = ref("DOM未就绪");
const windowStatus = ref("页面未完全加载");
const loadingProgress = ref(0);
// 方法2：监听window的load事件
const waitForWindowLoad = async () => {
  if (document.readyState === "complete") {
    windowStatus.value = "页面资源已完全加载";
    if (store.state.auth.user) {
      const promoteId =
        sessionStorage.getItem("promote_url_id") || getCookie("promote_url_id");
      if (promoteId) {
        await getEventCookie();
        const linkId = sessionStorage.getItem("link_id") || getCookie("link_id");
        const uuid = sessionStorage.getItem("uuid") || getCookie("uuid");
        if (linkId && uuid) {
          await GoogleTag("100");
        }
        if (localStorage.getItem("isNew") === "true") {
          const ok = await GoogleTag("101", { is_new: true });
          if (ok) {
            localStorage.removeItem("isNew");
          }
        }
      }
      await checkPendingDeposit(store.state.auth.user, store);
    }
  } else {
    window.addEventListener("load", async () => {
      windowStatus.value = "页面资源已完全加载";
      const promoteId =
        sessionStorage.getItem("promote_url_id") ||
        getCookie("promote_url_id");
      if (promoteId) {
        await getEventCookie();
        const linkId = sessionStorage.getItem("link_id") || getCookie("link_id");
        const uuid = sessionStorage.getItem("uuid") || getCookie("uuid");
        if (linkId && uuid) {
          await GoogleTag("100");
        }
        if (localStorage.getItem("isNew") === "true") {
          const ok = await GoogleTag("101", { is_new: true });
          if (ok) {
            localStorage.removeItem("isNew");
          }
        }
      }
    });
  }
};
// 统一的初始化逻辑
onMounted(async () => {
  rehydrateSessionFromCookie();
  const query = getUrlKey();
  if (query) {
    for (const key in query) {
      if (Object.prototype.hasOwnProperty.call(query, key)) {
        sessionStorage.setItem(key, query[key]);
        const whitelist = [
          "channel_id",
          "promote_url_id",
          "click_id",
          "fbclid",
          "link_id",
          "uuid",
        ];
        if (whitelist.includes(key)) {
          setCookie(key, String(query[key]));
        }
      }
    }
    // 检查是否需要打开注册弹窗
    if (query.invite_code === "register") {
      showLoginDialog.value = true;
      // 设置为注册模式的标识，可以通过sessionStorage传递给LoginDialog
      sessionStorage.setItem("openRegisterMode", "true");
    }
    // 检查是否需要跳转到充值页面
    if (query.invite_code === "recharge") {
      router.push("/m/records");
    }
    // //  测试事件
    // console.log('开始30秒倒计时')
    // setTimeout(()=>{
    //     GoogleTag("102");
    //     console.log('30秒倒计时结束')
    // },30000)
  }
  waitForWindowLoad();
  // 预加载任意资源，自动判断类型
  preloadWhenVisible(".some-block", "/api/data.json", {
    onLoaded: () => {
      console.log("Resource preloaded");
    },
  });
  initializeSystem();
  initSSE();
  // initWebSocket(); // 初始化WebSocket连接

  // 启动网络监控（这会自动处理网络状态变化和WebSocket重连）
  networkMonitor.startMonitoring();
  // 启动WebSocket连接保持器
  websocketKeeper.start();
  // 监听登录弹窗事件
  loginEvent.addEventListener(SHOW_LOGIN_EVENT, handleShowLogin);

  // 监听助力成功弹窗事件
  supportEvent.addEventListener(SUPPORT_EVENT, handleShowSupport);
  depositEvent.addEventListener(DEPOSIT_COMPLETED_EVENT, handleDepositCompleted as EventListener);
  if (localStorage.getItem("dialogOnce") !== "true") {
    getLoginPopupOnce();
  }

  // 添加快捷键监听
  document.addEventListener("keydown", handleKeyDown);
  document.addEventListener("keyup", handleKeyUp);

  // 监听路由变化，关闭 Toast
  router.beforeEach((to, from, next) => {
    if (to.path !== from.path) {
      closeToast();
    }
    next();
  });
  // 实时监听localStorage中orderId的变化
  const checkOrderIdChanges = () => {
    let lastOrderId = localStorage.getItem("orderId");

    const intervalId = setInterval(async () => {
      const currentOrderId = localStorage.getItem("orderId");

      // 如果orderId发生变化且用户已登录
      if (currentOrderId !== lastOrderId && store.state.auth.user) {
        lastOrderId = currentOrderId;

        // 如果新增了orderId，开始轮询
        if (currentOrderId) {
          console.log("Detected new deposit order ID:", currentOrderId);
          await checkPendingDeposit(store.state.auth.user, store);
        }
      }
    }, 1000); // 每秒检查一次

    return intervalId;
  };

  orderIdWatcherRef.value = checkOrderIdChanges();

  // 初始化版本服务，静默检查更新
  setTimeout(async () => {
    try {
      const { VersionService } = await import("@/services/versionService");
      await VersionService.getInstance().initialize();
    } catch (error) {
      console.error("Failed to initialize version service:", error);
    }
  }, 3000);



});

// 移除事件监听
onUnmounted(() => {
  clearProgressInterval();
  loginEvent.removeEventListener(SHOW_LOGIN_EVENT, handleShowLogin);
  supportEvent.removeEventListener(SUPPORT_EVENT, handleShowSupport);
  depositEvent.removeEventListener(DEPOSIT_COMPLETED_EVENT, handleDepositCompleted as EventListener);
  // 移除快捷键监听
  document.removeEventListener("keydown", handleKeyDown);
  document.removeEventListener("keyup", handleKeyUp);
  // 停止网络监控
  networkMonitor.stopMonitoring();
  // 停止WebSocket保持器
  websocketKeeper.stop();
  // 清理orderId监听定时器
  if (orderIdWatcherRef.value) {
    clearInterval(orderIdWatcherRef.value);
  }
  // 组件卸载时清除标记
  const pageKey = "pageOpened_" + route.path;
  sessionStorage.removeItem(pageKey);
  websocketService.disconnect(); // 卸载时关闭WebSocket连接

});
const testShow = ref(true);
</script>

<template>
  <v-app v-if="!isForbiddenCountry">
    <!-- 系统加载动画 -->
    <loading-spinner :show="isLoading" text="Carregando..." />

    <router-view v-show="!isLoading" v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>

    <!-- Toast 提示 -->
    <v-snackbar v-model="toast.show"  :timeout="toast.timeout" location="top">
      {{ toast.text }}
    </v-snackbar>

    <v-dialog v-model="supportSuccessDialog" width="283" center persistent :scrim="false">
      <div class="support-bg d-flex align-center position-relative">
        <div class="support-left">
          <v-icon icon="mdi-check-circle" color="#50EF7C"></v-icon>
        </div>
        <div class="support-right">
          <span class="support-right-text1">Ajudando o sucesso</span>
          <span class="support-right-text2">Amigos receberam recompensas</span>
        </div>
        <v-progress-linear class="progress-linear" v-model="progress" color="#50EF7C" height="4"
          striped></v-progress-linear>
      </div>
    </v-dialog>
    <!-- 登录弹窗 -->
    <login-dialog v-model="showLoginDialog" @login="handleLoginSuccess" :isLogin="isLogin" />
    <CommonDialog :show="commonDialogShow" @update:show="commonDialogShow = $event" :dialogObj="dialogObj" />
    <!-- 手机号绑定弹窗 -->
    <PhoneBindingDialog />
    <TelegramShareDialog />


    <AssistanceDialog :show="assistanceDialogShow" :activityStatus="activityStatus"
      @close="assistanceDialogShow = false" />

    <RewardDialog v-model:show="rewardDialog" :amount="rewardAmount" @close="rewardDialog = false" />

    <!-- 独立事件激活工具组件（封装所有激活逻辑） -->
    <EventActivatorTool />

    <!-- WebSocket状态监控 -->
    <WebSocketStatus />

    <!-- <UpdateNotification ref="updateNotification" /> -->
    <!-- 不再需要更新弹窗 -->
  </v-app>
  <ForbiddenCountry v-else />
</template>

<style lang="scss">
.progress-linear {
  position: absolute !important;
  bottom: 0;
  top: inherit !important;
}

/* 引入 Google Fonts */
@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;600;700&display=swap");

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 全局样式 */
html,
body {
  margin: 0;
  padding: 0;
  font-family: "Sofia Pro";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  min-height: 100vh;
}

.v-field__input {
  -webkit-user-select: text !important;
  user-select: text !important;
}

/* // 解决ios设备input聚焦异常问题。 */
/* 全局隐藏滚动条样式 */
#app ::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  display: none !important;
}

#app {
  scrollbar-width: none !important;
  /* Firefox */
  -ms-overflow-style: none !important;
  /* IE/Edge */
}

#app ::-webkit-scrollbar-thumb {
  background: transparent !important;
}

#app ::-webkit-scrollbar-track {
  background: transparent !important;
}

.support-bg {
  border-radius: 8px;
  overflow: hidden;
  background: #333333;
  width: 283px;
  height: 60px;

  .support-left {
    width: 50px;
    height: 100%;
    background: #444444;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .support-right {
    display: flex;
    flex-direction: column;
    margin-left: 10px;

    .support-right-text1 {
      // 
      font-weight: 600;
      font-size: 14px;
      color: #ffffff;
      line-height: 22px;
    }

    .support-right-text2 {
      // 
      font-weight: 500;
      font-size: 12px;
      color: #dddddd;
      line-height: 18px;
    }
  }
}

.v-overlay__scrim {
  background-color: black !important;
  opacity: 0.6 !important;
}

.v-snackbar__wrapper {
  margin-top: 10px;
  border: 1px solid #FF8398;
  background: #363F49 !important;
}

.v-snackbar__content {
  color: #fff;
}
</style>
